var map = {
	"./ar.png": 3341,
	"./br.png": 1024,
	"./ch.png": 7900,
	"./cl.png": 1983,
	"./co.png": 412,
	"./cz.png": 1906,
	"./de.png": 2553,
	"./es.png": 4894,
	"./fr.png": 9871,
	"./il.png": 2864,
	"./it.png": 1590,
	"./jp.png": 7385,
	"./local.png": 520,
	"./lu.png": 8376,
	"./ru.png": 8544,
	"./ua.png": 2357,
	"./us.png": 3374
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1061;